import { defineMessages } from 'react-intl';

export default defineMessages({
  currency: {
    id: 'currency',
    description: 'USD',
    defaultMessage: 'USD',
  },
  competitorDistributionLabel: {
    id: 'competitionChart.competitorDistribution',
    description: 'Competitor Distribution',
    defaultMessage: 'Competitor Distribution',
  },
  selectedTemplatesLabel: {
    id: 'competitionChart.selectedTemplates',
    description: 'Selected Templates',
    defaultMessage: 'Selected Templates',
  },
  clearFiltersLabel: {
    id: 'clearFilters',
    description: 'Clear Filters',
    defaultMessage: 'Clear Filters',
  },
});
